// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--1_djD";
export var btntransparentWhite = "button-module--btntransparent-white--WrCE6";
export var btntransparentTeal = "button-module--btntransparent-teal--1McC9";
export var btnsecondary = "button-module--btnsecondary--JaXFX";
export var btnprimary = "button-module--btnprimary--2q-bP";
export var usingMouse = "button-module--using-mouse--t6UMl";
export var link = "button-module--link--Ysr7y";
export var externalIcon = "button-module--external-icon--2n0o4";
export var btnlg = "button-module--btnlg--3coOe";
export var btnmd = "button-module--btnmd--3u7te";
export var btnsm = "button-module--btnsm--3Al_v";
export var btnxs = "button-module--btnxs--pIWIV";
export var btnhalf = "button-module--btnhalf--1MVRy";
export var btnfull = "button-module--btnfull--2gRKU";
export var btnhalfWithMargin = "button-module--btnhalf-with-margin--1Bety";
export var spinner = "button-module--spinner--1sd7S";